import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Action, Store } from '@ngrx/store';

import { ModalConfirm } from '@shared/modal/modal.actions';

@Component({
  selector: 'mojo-comment-modal',
  templateUrl: './modal-note.component.html',
  styleUrls: ['./modal-note.component.scss'],
})
export class ModalNoteComponent {
  @Input()
  confirmAction: Action;

  comments: UntypedFormControl = new UntypedFormControl();
  form: UntypedFormGroup = new UntypedFormGroup({
    comments: this.comments,
  });

  isDisableSave() {
    return !this.comments.value;
  }

  getConfirmAction() {
    return this.confirmAction
      ? [new ModalConfirm({ content: this.comments.value }), this.confirmAction]
      : [new ModalConfirm({ content: this.comments.value })];
  }
}
